$(function(){
  $('#uploader_file_field').submit(function (e) {
    if ($(this).find('input[name="file"]').val() == '') { 
      e.preventDefault();
      alert('select a file');
    }     
  });
})